type ChevronLeftIconProps = {
  size?: number
}

export function ChevronLeftIcon({ size = 24 }: ChevronLeftIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M12.2196 17.5302C12.5125 17.8231 12.9873 17.823 13.2802 17.5302C13.5731 17.2373 13.5731 16.7626 13.2802 16.4697L6.81043 9.99994L13.2802 3.53022C13.5731 3.23732 13.5731 2.76256 13.2802 2.46967C12.9873 2.17678 12.5125 2.17678 12.2196 2.46967L5.21961 9.46967C4.92687 9.76258 4.92676 10.2374 5.21961 10.5302L12.2196 17.5302Z" fill="currentColor" />
    </svg>
  )
}
